"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function getWrappedFunction(func, sourceCode) {
  var result = function result() {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return func.apply(this, args);
    } catch (e) {
      var message = "\u9879\u76EE\u4EE3\u7801\u6267\u884C\u51FA\u9519\uFF08\u975E\u5F15\u64CE\u5185\u90E8\u9519\u8BEF\uFF09\uFF01\u975E\u751F\u4EA7\u73AF\u5883\u53EF\u4EE5\u901A\u8FC7\u5728 URL \u4E0A\u52A0\u5165 ?debug_all \u6765\u6253\u5F00\u8C03\u8BD5\u6A21\u5F0F\u3002\u66F4\u591A\u8BF7\u70B9\u51FB\u8FD9\u91CC\uFF1Ahttps://ur.alipay.com/2JbYP\n--------------------------------------------------------\n\u9519\u8BEF\u4FE1\u606F\uFF1A".concat(e.message, "\n").concat(sourceCode ? "\u4EE5\u4E0B\u662F\u539F\u59CB\u51FD\u6570\uFF1A\n--------------------------------------------------------\n".concat(sourceCode, "\n--------------------------------------------------------") : '', "\n\u70B9\u51FB\u4E0B\u65B9\u51FD\u6570\u7684\u53EF\u4EE5\u8FDB\u5165\u5E76\u8C03\u8BD5\u65B9\u6CD5\uFF1A\n--------------------------------------------------------\n");
      console.error(message, func);
      return null;
    }
  };
  return result;
}
var USE_STRICT = /^(["'])use strict\1;?/i;

/**
 * parse a function string into Function object, isolateWindow (if any) will be used
 * as the window object instead of global window
 *
 * @param {String} func function string need parse
 * @param {Object} isolateWindow the isolateWindow used when running the action
 */
function _default(func, isolateWindow, legaoCtx) {
  var pluginCtx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.AliLowCodeEngine;
  var sourceCode = func;

  // 兼容 ES6 方案，即 funcString 为对象的情况
  if (_typeof(func) === 'object' && func !== null) {
    if (func.id) {
      var action;
      if (window.AliLowCodeEngine || pluginCtx) {
        var _plugins$visionUtils;
        action = (_plugins$visionUtils = (pluginCtx || window.AliLowCodeEngine).plugins.visionUtils) === null || _plugins$visionUtils === void 0 ? void 0 : _plugins$visionUtils.ActionUtil.getAction(func.id, {
          func: true
        });
      } else if (window.VisualEngineUtils) {
        action = window.VisualEngineUtils.ActionUtil.getAction(func.id, {
          func: true
        });
      } else if (window.LeGao && window.LeGao.getContext) {
        var _ctx = legaoCtx || window.LeGao.getContext();
        action = _ctx.getAction().actionsMap[func.id];
      }
      if (!action) {
        // const result = () => {
        //   console.error(`无法找到 ${func.id} 函数`);
        // };
        // fix 低代码组件在页面设计器时，渲染报错 http://gitlab.alibaba-inc.com/uipaas/issues/issues/110276
        console.error("\u65E0\u6CD5\u627E\u5230 ".concat(func.id, " \u51FD\u6570"));
        return null;
      }
      return getWrappedFunction(action.func);
    }
    sourceCode = func.source;
    func = func.compiled || func.source || '';
  }
  if (!func) {
    var result = function result() {
      window.location.search.indexOf('dev') >= 0 && console.log('解析的函数为空');
    };
    return result;
  }
  if (typeof func === 'function') {
    // TODO: un-annotate these code after vision-render-service done
    // if (isolateWindow) {
    //   return func(isolateWindow);
    // }
    return func;
  }
  var code = '';
  if (func.indexOf('var __preParser__') >= 0 && func.indexOf('function') !== 0) {
    code = "\n      ".concat(func, "\n      if (typeof __preParser__ === 'function') {\n        return __preParser__.apply(this, Array.prototype.slice.call(arguments));\n      }\n      console.warn('code must be a string of function');\n    ");
  } else {
    code = "\n      var __preParser__ = ".concat(func.replace(USE_STRICT, ''), ";\n      if (typeof __preParser__ === 'function') {\n        return __preParser__.apply(this, Array.prototype.slice.call(arguments));\n      }\n      console.warn('code must be a string of function');\n    ");
  }
  try {
    if (isolateWindow) {
      code = "\n        return function() {\n          ".concat(code, "\n        }\n      ");
      func = new Function('window', code)(isolateWindow);
    } else {
      func = new Function(code);
    }
  } catch (e) {
    console.error('解析 function 字符串失败，请检查字符串的合法性', e.message, "\n".concat(sourceCode));
    func = function func() {
      console.error('代码配置有误，请检查相关配置');
    };
  }
  return getWrappedFunction(func, sourceCode);
}
module.exports = exports.default;